import {Pipe, PipeTransform} from '@angular/core';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {Features} from '../services/auth/features';
import {User} from '../classes/user.class';

@Pipe({
    name: 'hasFeature',
})
export class HasFeaturePipe implements PipeTransform {

    transform(value: Features | Features[], user?: User): boolean {
        if (typeof value === 'object') {
            return AuthorisationService.hasAnyFeature(value, user);
        } else {
            return AuthorisationService.hasFeature(value, user);
        }
    }
}
